import { useState, useEffect } from "react";
import Sidebar from "../../components/Navigation/Sidebar";
import Topbar from "../../components/Navigation/Topbar";
import Grid from "../../components/Grid";
import { connect } from "react-redux";

const ExternalInventory = ({
  reduxGetExternalInventory,
  externalInventory
}) => {
  const [range, setRange] = useState(25);

  useEffect(() => {
    reduxGetExternalInventory({
      pageSize: range,
    });
  }, [range]);

  const columns = [
    {
      title: "#",
      render: (rowData) => {
        return <span>{rowData?.product?.sku}</span>;
      },
      searchable: false,
    },
    {
      title: "Nombre",
      render: (rowData) => {
        return <span>{rowData?.product?.name}</span>;
      },
      searchable: false,
    },
    {
      title: "Stock Real",
      render: (rowData) => {
        return <span>{rowData?.on_hand}</span>;
      },
      searchable: false,
    },
    {
      title: "Reserva",
      render: (rowData) => {
        return <span>{rowData?.reserve_inventory}</span>;
      },
      searchable: false,
    },
    {
      title: "Cant reorden",
      render: (rowData) => {
        return <span>{rowData?.reorder_amount}</span>;
      },
      searchable: false,
    },
    {
      title: "Nivel reorden",
      render: (rowData) => {
        return <span>{rowData?.reorder_level}</span>;
      },
      searchable: false,
    },
    {
      title: "Asignado",
      render: (rowData) => {
        return <span>{rowData?.allocated}</span>;
      },
      searchable: false,
    },
    {
      title: "Disponible",
      render: (rowData) => {
        return <span>{rowData?.available}</span>;
      },
      searchable: false,
    },
    {
      title: "Pedido pendiente",
      render: (rowData) => {
        return <span>{rowData?.backorder}</span>;
      },
      searchable: false,
    },
    {
      title: "Alistado",
      render: (rowData) => {
        return <span>{rowData?.in_tote}</span>;
      },
      searchable: false,
    },
    {
      title: "No vendible",
      render: (rowData) => {
        return <span>{rowData?.non_sellable_quantity}</span>;
      },
      searchable: false,
    },
    {
      title: "Venta anticipada",
      render: (rowData) => {
        return <span>{rowData?.sell_ahead}</span>;
      },
      searchable: false,
    }
  ];


  return (
    <div>
      <div id="wrapper">
        <Sidebar />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Topbar />
            <div className="container-fluid">
              <div className="d-sm-flex align-items-center mb-1">
                <h1 className="h3 mb-0 text-gray-800 mr-3">Inventario Externo</h1>
              </div>
              <p className="mb-4">Módulo para la gestión del Inventario de Bodegas Externas</p>
              <div className="card shadow mb-4">
                <div className="card-header py-3">
                  <h6 className="m-0 font-weight-bold text-primary">
                    Listado de Inventario de Bodegas Externas
                  </h6>
                </div>
                <div className="card-body">
                  <Grid
                    showRange={true}
                    showFilters={false} 
                    cols={columns}
                    data={
                      externalInventory
                        ? externalInventory?.edges
                        : []
                    }
                    page={1}
                    pages={1}
                    defaultValue={null}
                    total={
                      externalInventory && externalInventory?.hasOwnProperty("totalCount")
                        ? externalInventory?.totalCount
                        : 0
                    }
                    offset={range}
                    onChangeRange={(value) => {
                      setRange(value);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    externalInventory: state.externalInventoryState.externalInventory
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetExternalInventory: (payload) =>
      dispatch({
        type: "FETCH_EXTERNAL_INVENTORY_REQUEST",
        value: payload,
      })
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExternalInventory);
